// source: pbtypes/vehicle/skills/actions/track_landing_pad_request/track_landing_pad_request.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_landing_pad_track_landing_pad_request_source_pb = require('../../../../../pbtypes/gen/landing_pad/track_landing_pad_request_source_pb.js');
goog.object.extend(proto, pbtypes_gen_landing_pad_track_landing_pad_request_source_pb);
var pbtypes_gen_landing_pad_landing_pad_type_pb = require('../../../../../pbtypes/gen/landing_pad/landing_pad_type_pb.js');
goog.object.extend(proto, pbtypes_gen_landing_pad_landing_pad_type_pb);
goog.exportSymbol('proto.skills.TrackLandingPadRequestActionArgs', null, global);
goog.exportSymbol('proto.skills.TrackLandingPadRequestActionStateData', null, global);
goog.exportSymbol('proto.skills.TrackLandingPadRequestResultData', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skills.TrackLandingPadRequestActionArgs = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skills.TrackLandingPadRequestActionArgs, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skills.TrackLandingPadRequestActionArgs.displayName = 'proto.skills.TrackLandingPadRequestActionArgs';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skills.TrackLandingPadRequestResultData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skills.TrackLandingPadRequestResultData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skills.TrackLandingPadRequestResultData.displayName = 'proto.skills.TrackLandingPadRequestResultData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skills.TrackLandingPadRequestActionStateData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skills.TrackLandingPadRequestActionStateData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skills.TrackLandingPadRequestActionStateData.displayName = 'proto.skills.TrackLandingPadRequestActionStateData';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skills.TrackLandingPadRequestActionArgs.prototype.toObject = function(opt_includeInstance) {
  return proto.skills.TrackLandingPadRequestActionArgs.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skills.TrackLandingPadRequestActionArgs} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.TrackLandingPadRequestActionArgs.toObject = function(includeInstance, msg) {
  var f, obj = {
source: jspb.Message.getFieldWithDefault(msg, 1, 0),
enableTracker: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
enableImageSpace: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
timeoutS: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
waitForActiveTrack: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
landingPadType: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skills.TrackLandingPadRequestActionArgs}
 */
proto.skills.TrackLandingPadRequestActionArgs.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skills.TrackLandingPadRequestActionArgs;
  return proto.skills.TrackLandingPadRequestActionArgs.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skills.TrackLandingPadRequestActionArgs} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skills.TrackLandingPadRequestActionArgs}
 */
proto.skills.TrackLandingPadRequestActionArgs.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.landing_pad.TrackLandingPadRequestSource.Enum} */ (reader.readEnum());
      msg.setSource(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableTracker(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableImageSpace(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setTimeoutS(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setWaitForActiveTrack(value);
      break;
    case 6:
      var value = /** @type {!proto.landing_pad.LandingPadType.Enum} */ (reader.readEnum());
      msg.setLandingPadType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skills.TrackLandingPadRequestActionArgs.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skills.TrackLandingPadRequestActionArgs.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skills.TrackLandingPadRequestActionArgs} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.TrackLandingPadRequestActionArgs.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSource();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getEnableTracker();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getEnableImageSpace();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getTimeoutS();
  if (f !== 0.0) {
    writer.writeFloat(
      4,
      f
    );
  }
  f = message.getWaitForActiveTrack();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getLandingPadType();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
};


/**
 * optional landing_pad.TrackLandingPadRequestSource.Enum source = 1;
 * @return {!proto.landing_pad.TrackLandingPadRequestSource.Enum}
 */
proto.skills.TrackLandingPadRequestActionArgs.prototype.getSource = function() {
  return /** @type {!proto.landing_pad.TrackLandingPadRequestSource.Enum} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.landing_pad.TrackLandingPadRequestSource.Enum} value
 * @return {!proto.skills.TrackLandingPadRequestActionArgs} returns this
 */
proto.skills.TrackLandingPadRequestActionArgs.prototype.setSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional bool enable_tracker = 2;
 * @return {boolean}
 */
proto.skills.TrackLandingPadRequestActionArgs.prototype.getEnableTracker = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.skills.TrackLandingPadRequestActionArgs} returns this
 */
proto.skills.TrackLandingPadRequestActionArgs.prototype.setEnableTracker = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional bool enable_image_space = 3;
 * @return {boolean}
 */
proto.skills.TrackLandingPadRequestActionArgs.prototype.getEnableImageSpace = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.skills.TrackLandingPadRequestActionArgs} returns this
 */
proto.skills.TrackLandingPadRequestActionArgs.prototype.setEnableImageSpace = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional float timeout_s = 4;
 * @return {number}
 */
proto.skills.TrackLandingPadRequestActionArgs.prototype.getTimeoutS = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skills.TrackLandingPadRequestActionArgs} returns this
 */
proto.skills.TrackLandingPadRequestActionArgs.prototype.setTimeoutS = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional bool wait_for_active_track = 5;
 * @return {boolean}
 */
proto.skills.TrackLandingPadRequestActionArgs.prototype.getWaitForActiveTrack = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.skills.TrackLandingPadRequestActionArgs} returns this
 */
proto.skills.TrackLandingPadRequestActionArgs.prototype.setWaitForActiveTrack = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional landing_pad.LandingPadType.Enum landing_pad_type = 6;
 * @return {!proto.landing_pad.LandingPadType.Enum}
 */
proto.skills.TrackLandingPadRequestActionArgs.prototype.getLandingPadType = function() {
  return /** @type {!proto.landing_pad.LandingPadType.Enum} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.landing_pad.LandingPadType.Enum} value
 * @return {!proto.skills.TrackLandingPadRequestActionArgs} returns this
 */
proto.skills.TrackLandingPadRequestActionArgs.prototype.setLandingPadType = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skills.TrackLandingPadRequestResultData.prototype.toObject = function(opt_includeInstance) {
  return proto.skills.TrackLandingPadRequestResultData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skills.TrackLandingPadRequestResultData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.TrackLandingPadRequestResultData.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skills.TrackLandingPadRequestResultData}
 */
proto.skills.TrackLandingPadRequestResultData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skills.TrackLandingPadRequestResultData;
  return proto.skills.TrackLandingPadRequestResultData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skills.TrackLandingPadRequestResultData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skills.TrackLandingPadRequestResultData}
 */
proto.skills.TrackLandingPadRequestResultData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skills.TrackLandingPadRequestResultData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skills.TrackLandingPadRequestResultData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skills.TrackLandingPadRequestResultData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.TrackLandingPadRequestResultData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skills.TrackLandingPadRequestActionStateData.prototype.toObject = function(opt_includeInstance) {
  return proto.skills.TrackLandingPadRequestActionStateData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skills.TrackLandingPadRequestActionStateData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.TrackLandingPadRequestActionStateData.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skills.TrackLandingPadRequestActionStateData}
 */
proto.skills.TrackLandingPadRequestActionStateData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skills.TrackLandingPadRequestActionStateData;
  return proto.skills.TrackLandingPadRequestActionStateData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skills.TrackLandingPadRequestActionStateData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skills.TrackLandingPadRequestActionStateData}
 */
proto.skills.TrackLandingPadRequestActionStateData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skills.TrackLandingPadRequestActionStateData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skills.TrackLandingPadRequestActionStateData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skills.TrackLandingPadRequestActionStateData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.TrackLandingPadRequestActionStateData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


goog.object.extend(exports, proto.skills);
